import { Component, Input } from '@angular/core';
import { ConstrainedField } from '@app/shared/models/constrained-field';

@Component({
  selector: 'app-translated-cell',
  templateUrl: './translated-cell.component.html',
  styleUrls: ['./translated-cell.component.scss'],
})
export class TranslatedCellComponent {
  @Input() public field!: ConstrainedField;
  @Input() public languages!: string[];

  public toDbModel(value: any): any {
    let readValue = {};

    const key = this.field.key;

    let translations = [];
    this.languages.forEach(lang => {
      let langField = `${key}_${lang}`
      let langObj = {
        lang,
        text: value[langField]
      };
      translations.push(langObj);
    });

    readValue[`${key}_Dic`] = translations;
    readValue[key] = value[key];
    
    return readValue;
  }
}
